import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoPlanoSaude } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoPlanoSaudeService extends BaseResourceService<FavorecidoPlanoSaude> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-plano-saude`, injector);
  }

}
